module.exports = __webpack_public_path__ + "static/img/solution-content1.5a413f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution-content1.png
// module id = JcUg
// module chunks = 0